import { palette } from '../palette';

const MuiMenuItem = {
    styleOverrides: {
        root: {
            color:palette.info.dark,//#43424c
            fontSize:'1rem',
            fontWeight:400,
        }
    },
};

export default MuiMenuItem;
